var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternetFail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350 552 c-107 -53 -107 -211 0 -264 134 -68 279 93 192 212 -49 66 -124 87 -192 52z m141 -61 c87 -87 -29 -228 -131 -159 -38 26 -56 71 -46 113 19 77 120 103 177 46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 500 c-57 -23 -71 -100 -28 -144 46 -45 122 -28 145 31 14 37 -6 90 -41 108 -32 17 -45 18 -76 5z m46 -55 c0 -19 -4 -35 -10 -35 -5 0 -10 16 -10 35 0 19 5 35 10 35 6 0 10 -16 10 -35z m0 -76 c0 -5 -4 -9 -10 -9 -5 0 -10 7 -10 16 0 8 5 12 10 9 6 -3 10 -10 10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 451 c-41 -25 -47 -36 -29 -51 9 -7 17 -11 18 -9 2 2 15 21 30 42 31 42 27 46 -19 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 423 c-14 -21 -25 -41 -25 -44 0 -4 18 -11 41 -17 39 -10 41 -9 35 11 -3 12 -6 37 -6 55 0 42 -13 41 -45 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 368 c-9 -18 -18 -45 -22 -60 -6 -26 -4 -28 29 -28 32 0 35 2 41 38 3 20 6 41 7 46 1 5 -8 15 -19 23 -20 13 -22 11 -36 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 327 c-9 -46 -9 -47 44 -47 48 0 50 1 50 28 0 24 -5 29 -44 38 -44 10 -44 10 -50 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 303 c0 -17 6 -23 23 -23 16 0 18 3 8 9 -7 5 -17 15 -22 22 -6 10 -9 8 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 233 c9 -36 32 -83 42 -83 16 1 42 28 38 41 -2 8 -7 26 -10 42 -6 23 -11 27 -41 27 -33 0 -35 -1 -29 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 228 c3 -17 8 -33 10 -35 2 -3 22 1 45 7 34 9 41 15 41 35 0 23 -3 25 -51 25 l-51 0 6 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 235 c0 -20 7 -26 41 -35 23 -6 42 -10 44 -8 1 2 6 18 10 36 l7 32 -51 0 c-48 0 -51 -2 -51 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 252 c-28 -3 -32 -7 -37 -40 -4 -35 11 -62 35 -62 13 0 39 60 36 83 -2 18 -9 21 -34 19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 178 c-26 -9 -27 -11 -14 -36 8 -15 26 -38 40 -51 l26 -24 0 61 c0 66 -3 69 -52 50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 128 l0 -61 26 24 c14 13 32 36 40 51 13 25 12 27 -18 37 -17 6 -35 11 -39 11 -5 0 -9 -28 -9 -62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 136 c-9 -11 -5 -18 22 -35 46 -28 50 -27 26 14 -23 38 -31 42 -48 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352 118 c-12 -18 -19 -34 -17 -36 2 -3 20 6 40 18 29 18 33 25 24 36 -17 21 -25 18 -47 -18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetFail);
export default __webpack_public_path__ + "static/media/internet-fail.f199d52b35cd77c435a17a03697b3cf9.svg";
export { ForwardRef as ReactComponent };